import React from 'react'
import mainservice from '../../services/MainService'
import Spinner from '../Spinner/Spinner'
// import UserDTO, {IUser} from '../../DTO/UserDTO'
// import { Getter } from '../../services/ComService'
import UserLogin from './UserLogin'
import './User.scss'
import { Book, Briefcase, Key, PieChart, Users } from 'react-feather'
import { i18n } from '../../services/i18n'

type Props = {
}

type State = {
  loading: boolean,
  loggedIn: boolean,
}

class User extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      loading: true,
      loggedIn: false
    }
  }
  async componentDidMount() {
    if (await mainservice.loginService.isLoggedIn()) {
      this.setLoggedIn()
    }
    this.setState({
      loading: false
    })
  }

  isAdminLike() {
    const user = mainservice.loginService.user
    console.log('ISADMINLIKE', user)
    return user.roles.some((r: string) => r.search(/(ADMIN|PLANER)/) > -1)
  }

  isAdmin() {
    const user = mainservice.loginService.user
    console.log('ISADMIN', user)
    return user.roles.some((r: string) => r.search(/(ADMIN)/) > -1)
  }

  setLoggedIn() {
    if (this.isAdminLike()) {
      mainservice.becomeAdmin()
      this.setState({
        loading: false,
        loggedIn: true
      })
    } else {
      const view: string = mainservice.nav.getVal('view') as string
      if (view.search(/base|login/) > -1) {
        mainservice.navTo([['view', 'dashboard']])
      }
    }
  }


  async setLoggedOut() {
    mainservice.quitAdmin()
    await mainservice.loginService.logout()
    this.setState({
      loggedIn: false,
    })
  }

  render() {
    const user = mainservice.loginService.user
    if (this.state.loading) {
      return <div className="center">
        <Spinner />
      </div>
    }
    if (!this.state.loggedIn) {
      return <>
        <UserLogin
          setLoggedIn={ () => this.setLoggedIn() }
        />
        <footer className='loginFooter'>
          <a rel="noreferrer" href={i18n('impressumLink')} target='_blank'>{i18n('impressum')}</a>&nbsp;
          <a rel="noreferrer" href={i18n('dataprotectionLink')} target='_blank'>{i18n('dataprotection')}</a>
        </footer>
      </>
    }

    const AdminCategories = [
      {
        title: 'Bücher',
        icon: <Book />,
        items: [
          {
            view: 'overview',
            name: 'Buch-Übersicht',
            whiteListetGroups: [],
          },
          {
            view: 'CollectibleListA',
            name: 'Sammelstücke',
            whiteListetGroups: [],
          },
          {
            view: 'widgetsAdmin',
            name: 'Widgets',
            whiteListetGroups: [1],
          },
          {
            view: 'fileList',
            name: 'Medien',
            whiteListetGroups: [],
          },
          {
            view: 'watermarks',
            name: 'Wasserzeichen',
            whiteListetGroups: [],
          },
        ]
      },
      {
        title: 'Benutzer',
        icon: <Users />,
        items: [
          {
            view: 'userList',
            name: 'Benutzer Liste',
            whiteListetGroups: [],
          },
          {
            view: 'BulkGenerateUsers',
            name: 'Benutzer hinzufügen',
            whiteListetGroups: [],
          },
          {
            view: 'unitList',
            name: 'Benutzer Gruppen',
            whiteListetGroups: [1],
          },
        ]
      },
      {
        title: 'Auswertung',
        icon: <PieChart />,
        items: [
          {
            view: 'coach',
            name: 'Coach-Tool / FSA',
            whiteListetGroups: [1],
          },
          {
            view: 'coachLegacy',
            name: 'Coach-Tool-Legacy / FSA',
            whiteListetGroups: [1],
          },
          {
            view: 'BookSurveyA',
            name: 'Auswertung',
            whiteListetGroups: [1],
          },
        ]
      },
      {
        title: 'Administration',
        icon: <Key />,
        items: [
          {
            view: 'StaticPageAdmin',
            name: 'StaticPageAdmin',
            whiteListetGroups: [],
          },
          {
            view: 'preferences',
            name: 'Einstellungen',
            whiteListetGroups: [],
          },
          {
            view: 'shoppingCarts',
            name: 'Einkaufswagen',
            whiteListetGroups: [1],
          },
        ]
      }, {
        title: 'Klienten',
        icon: <Briefcase />,
        items: [
          {
            view: 'clients',
            name: 'Mandanten verwalten',
            whiteListetGroups: [1],
          },
          {
            view: 'SendBook2Client',
            name: 'Buch an Mandanten verschicken',
            whiteListetGroups: [1],
          },
        ]
      }
    ]

    return <div className='admin-tool'>
      <h1>Admin Dashboard</h1>
      <div className="flex flex-wrap flex-stretch flex-gap">
        
        { this.isAdmin() &&
          <>
            {
              AdminCategories.map((category, index) => {
                const items = category.items.filter((i) => {
                  if (user.isInOneGroup(i.whiteListetGroups)) {
                    return true
                  }
                  return false
                })
                if (items.length === 0) {
                  return null
                }
                return <div
                  key={`admin-category-${index}`}
                  className='w3-card w3-border w3-padding flex flex-column flex-gap'
                >
                  <h2>{category.icon} {category.title}</h2>
                  {
                    items.map((i, index) => {
                      return <a
                        className="w3-button w3-white w3-btn"
                        key={`admin-menu-item-${index}`}
                        href={`/view=${i.view}`}
                        onClick={(e) => {
                          e.preventDefault()
                          mainservice.navTo([['view', i.view]])
                        }}
                      >{i.name}</a>
                    })
                  }
                </div>
              })
            }
          </>
        }
        <button className="w3-button w3-white w3-btn" onClick={() => this.setLoggedOut()}>Ausloggen</button>
      </div>
    </div>
  }
}

export default User
